import { Injectable } from '@angular/core';
import { CustomBasePageMetaResolver, PageSubTitleResolver } from '@core/feature';
import {
  BreadcrumbMeta,
  CanonicalPageResolver,
  PageBreadcrumbResolver,
  PageMetaResolver,
  PageRobotsMeta,
  PageRobotsResolver,
  PageTitleResolver,
  PageType,
  PageTypeResolver,
  RoutingService,
} from '@spartacus/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseProductListPageMetaResolver } from './base-product-list-page-meta.resolver';

@Injectable({
  providedIn: 'root',
})
export class CustomSearchPageMetaResolver
  extends PageMetaResolver
  implements
    PageTitleResolver,
    PageSubTitleResolver,
    PageBreadcrumbResolver,
    PageRobotsResolver,
    CanonicalPageResolver,
    PageTypeResolver
{
  private query$: Observable<string> = this.routingService
    .getRouterState()
    .pipe(map((state) => state.state.queryParams.freeTextSearch));

  constructor(
    private routingService: RoutingService,
    private basePageMetaResolver: CustomBasePageMetaResolver,
    private baseProductListPageMetaResolver: BaseProductListPageMetaResolver,
  ) {
    super();
    this.pageType = PageType.CONTENT_PAGE;
    this.pageTemplate = 'SearchResultsGridPageTemplate';
  }

  resolveTitle(): Observable<string> {
    return this.query$.pipe(
      // если ссылка поисковой подсказки будет содержать кириллицу,
      // то ее нужно декодировать
      map((title: string) => decodeURI(title)),
    );
  }

  resolveSubTitle(): Observable<string> {
    return this.baseProductListPageMetaResolver.getSearchPageSubTitle();
  }

  resolveBreadcrumbs(): Observable<BreadcrumbMeta[]> {
    return this.basePageMetaResolver.resolveBreadcrumbs();
  }

  resolveRobots(): Observable<PageRobotsMeta[]> {
    return this.basePageMetaResolver.resolveRobots();
  }

  resolveCanonicalUrl(): Observable<string> {
    return this.basePageMetaResolver.resolveCanonicalUrl();
  }

  resolveType(): Observable<string> {
    return this.basePageMetaResolver.resolveType();
  }
}
